var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAward04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "award-04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.65719 10.3215L3.52592 6.40739C3.33099 6.16374 3.23353 6.04192 3.16423 5.90626C3.10274 5.7859 3.0578 5.65779 3.03063 5.52539C3 5.37617 3 5.22015 3 4.90813V4.4C3 3.55992 3 3.13988 3.16349 2.81901C3.3073 2.53677 3.53677 2.3073 3.81901 2.16349C4.13988 2 4.55992 2 5.4 2H12.6C13.4401 2 13.8601 2 14.181 2.16349C14.4632 2.3073 14.6927 2.53677 14.8365 2.81901C15 3.13988 15 3.55992 15 4.4V4.90813C15 5.22015 15 5.37617 14.9694 5.52539C14.9422 5.65779 14.8973 5.7859 14.8358 5.90626C14.7665 6.04192 14.669 6.16374 14.4741 6.40739L11.3428 10.3215M3.75004 2.75L9.00004 9.5L14.25 2.75M11.6517 10.5983C13.1161 12.0628 13.1161 14.4372 11.6517 15.9017C10.1872 17.3661 7.81282 17.3661 6.34835 15.9017C4.88388 14.4372 4.88388 12.0628 6.34835 10.5983C7.81281 9.13388 10.1872 9.13388 11.6517 10.5983Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward04);
export default __webpack_public_path__ + "static/media/award-04.06222432f2fd857788ea74101067a9cc.svg";
export { ForwardRef as ReactComponent };